import { getAlertDisplayName } from '@/common/alertType';
import {
  RunStepDetailField,
  RunStepDetailFieldList,
} from '../../runHistory/RunStepDetailField';
import type { RunStepDetailProps } from '../../types';

/** Shows the alert that started the run, as it was when the trigger fired, and its shipment. */
export function AlertTriggerRunStepDetail({ step }: RunStepDetailProps) {
  const report = step.report?.alert_trigger;
  if (report === undefined) {
    return null;
  }
  const alertName = getAlertDisplayName(report.alert_type, report.title);
  const currentValue = [report.current_value, report.current_unit]
    .filter((part) => part !== '')
    .join(' ');
  return (
    <RunStepDetailFieldList>
      <RunStepDetailField label='Alert'>{alertName}</RunStepDetailField>
      {report.title !== '' && report.title !== alertName && (
        <RunStepDetailField label='Title'>{report.title}</RunStepDetailField>
      )}
      {report.current_value !== '' && (
        <RunStepDetailField label='Current value'>
          {currentValue}
        </RunStepDetailField>
      )}
      {report.threshold_value !== '' && (
        <RunStepDetailField label='Threshold'>
          {report.threshold_value}
        </RunStepDetailField>
      )}
      {report.shipment_reference_number !== '' && (
        <RunStepDetailField label='Shipment'>
          {report.shipment_reference_number}
        </RunStepDetailField>
      )}
      {report.shipment_courier_name !== '' && (
        <RunStepDetailField label='Courier'>
          {report.shipment_courier_name}
        </RunStepDetailField>
      )}
    </RunStepDetailFieldList>
  );
}
